import { defineStore } from "pinia";
import { ref } from "vue";
import StoreItem from "@/shared/model/StoreItem";

export const useStoreStore = defineStore("store", () => {
  const currentItem = ref<StoreItem|undefined>(undefined)

  return { currentItem };
});
